{/* Auto-generated icon - do not edit */}
import React from 'react'

interface SearchIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const SearchIcon = React.forwardRef<SVGSVGElement, SearchIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 160 154"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M36.73 101.022C47.6036 102.903 58.4481 102.055 69.8857 98.429C76.5559 96.3644 82.9172 93.4005 88.7963 89.6197C89.9022 90.855 90.997 92.0837 92.0808 93.3066C94.7416 96.3037 97.2603 99.1351 99.8939 101.976C112.764 115.861 126.727 129.064 140.231 141.832C142.685 144.154 145.138 146.477 147.59 148.801C149.512 150.565 151.623 152.107 153.885 153.399C154.443 153.698 155.07 153.846 155.702 153.827C156.364 153.837 157.019 153.699 157.621 153.422C157.947 153.258 158.236 153.029 158.473 152.749C158.709 152.47 158.887 152.146 158.997 151.796C159.126 151.38 159.173 150.942 159.133 150.506C159.094 150.072 158.97 149.65 158.769 149.263C157.7 147.016 156.395 144.891 154.875 142.925C152.425 140.004 149.819 137.218 147.068 134.581C140.66 128.347 134.119 122.039 127.793 115.937C123.406 111.708 119.023 107.475 114.643 103.238C110.121 98.8597 105.718 94.5588 101.057 89.9988C99.1592 88.143 97.2486 86.2767 95.3264 84.4L95.5756 84.1253C95.9377 83.7272 96.2187 83.4179 96.5179 83.1262C103.803 76.0331 107.798 67.1592 108.39 56.7533C109.42 38.6831 103.361 23.3432 90.3863 11.1543C84.0296 5.04049 75.783 1.29956 67.0179 0.553903C58.4932 -0.270596 49.8914 0.711922 41.768 3.43809C29.314 7.69659 18.7422 15.8664 10.3477 27.7211C3.11482 37.9347 0.215761 49.2675 1.73113 61.4047C2.71952 69.3243 5.90734 76.8292 12.0662 85.7403C17.8862 94.1575 25.9524 99.156 36.73 101.022ZM49.609 12.7583C52.506 12.511 55.5017 12.2559 58.4435 12.158C58.942 12.1424 59.4356 12.1343 59.9245 12.1338C73.3337 12.1338 83.6376 18.2501 90.5667 30.3293C96.7684 41.138 98.5226 51.4965 95.9312 61.9959C95.0427 65.9331 93.2691 69.6134 90.7459 72.7534C87.6145 76.5819 83.8089 79.797 79.5185 82.2381C69.7235 87.8291 58.7062 90.9019 47.4459 91.1838C46.366 91.0638 45.2835 90.9574 44.201 90.851C41.8154 90.6174 39.348 90.3747 36.9578 89.9825C31.0166 89.082 25.618 85.9994 21.8041 81.3311C17.1561 75.8798 13.8004 69.4379 11.9902 62.4919C9.91428 54.4407 10.6709 45.9153 14.1319 38.3609C17.9959 29.7323 23.128 23.366 29.8223 18.8987C35.1789 15.3247 40.0625 13.4866 45.1894 13.116C46.6633 13.0096 48.1345 12.8836 49.6064 12.7583H49.609Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="159" height="154" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

SearchIcon.displayName = 'SearchIcon'
